'use client';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { useAccountUm } from '@/hooks/use-account-um';
import { useGlobalContext } from '@/store/contexts/global-context';
import { LIVESTREAM_PAGE_ENTRY_POINT_DEFAULTS } from './constants';
import type { LivestreamPageEntryPointCommonProps } from './types';
import './styles/@theme';

const LiveStreamPreviewCard = dynamic(
    () => import('@fanduel/casino-streaming-um-web').then((module) => module.LiveStreamPreviewCard),
    { ssr: false }
);

export const LivestreamPageInfluencerHubEntryPoint = ({
    categoryPath,
    label,
    previewImageUrl,
    avatarUrl,
    previewTitle = 'Casino Livestream'
}: LivestreamPageEntryPointCommonProps) => {
    const router = useRouter();
    const { isLoggedIn } = useGlobalContext();
    const { triggerLogin } = useAccountUm();

    if (!previewImageUrl || !categoryPath) {
        return null;
    }

    const handleCtaClick = () => {
        if (!isLoggedIn) {
            triggerLogin({ externalReferrer: categoryPath.replace(/^\/+/, '') });
            return;
        }

        router.push(categoryPath);
    };

    return (
        <div className="livestream-page-entry-point" data-testid="livestream-preview-card-zone">
            <LiveStreamPreviewCard
                label={
                    label
                        ? {
                              text: label,
                              style: { color: 'var(--livestream-zone-title-color)' }
                          }
                        : undefined
                }
                preview={{
                    image: { src: previewImageUrl },
                    avatar: avatarUrl ? { src: avatarUrl } : undefined,
                    title: previewTitle
                }}
                cta={{
                    label: LIVESTREAM_PAGE_ENTRY_POINT_DEFAULTS.CTA_LABEL,
                    onClick: handleCtaClick
                }}
            />
        </div>
    );
};
